import {
    Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Icon, Typography, CircularProgress
} from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';

const Days = () => {
    const [details, setDetails] = useState({ name: "", date: "", start_time: "", end_time: "", quiz_duration: "" });
    const [open, setOpen] = useState(false);
    const [days, setDays] = useState([]);
    const [formType, setFormType] = useState('add');
    const [loading, setLoading] = useState(false);

    const handleOpen = (type, item = { name: "", date: "", start_time: "", end_time: "", quiz_duration: "" }) => {
        setFormType(type);
        setDetails({ ...item, date: item?.date?.slice(0, 10) });
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (formType === 'add') {
                await axios.post(`${URL}/api/admin/day`, data);
                Swal.fire("Day created!");
            } else {
                await axios.patch(`${URL}/api/admin/day/${data._id}`, data);
                Swal.fire("Day updated!");
            }
            handleClose();
            getDays();
        } catch (error) {
            Swal.fire("Something went wrong!");
            console.error("Save error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will delete the day permanently.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${URL}/api/admin/day/${id}`);
                    Swal.fire("Deleted successfully!");
                    getDays();
                } catch (error) {
                    console.error("Delete error:", error);
                }
            }
        });
    };

    const getDays = async () => {
        try {
            const res = await axios.get(`${URL}/api/admin/day`);
            setDays(res.data.data || []);
        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        getDays();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/* <Box display="flex" mb={3} justifyContent="end">
                <Button
                    startIcon={<Icon>add</Icon>}
                    variant="contained"
                    color="primary"
                    style={{ color: 'white' }}
                    onClick={() => handleOpen('add')}
                >
                    Add Day
                </Button>
            </Box> */}

            <AptaTable
                columns={['Name', 'Date', 'Start Time', 'End Time', 'Quiz Duration', 'Questions', 'Actions']}
                rows={days?.map((item) => ({
                    Name: item?.name,
                    Date: item?.date?.slice(0, 10),
                    'Start Time': item?.start_time?.slice(0, 5),
                    'End Time': item?.end_time?.slice(0, 5),
                    'Quiz Duration': item?.quiz_duration + " mins",
                    'Questions': item?.total_questions || 0,
                    Actions: (
                        <ButtonGroup size='small'>
                            <Button color='info' onClick={() => handleOpen('edit', item)}>
                                <Icon color='info'>edit</Icon>
                            </Button>
                            <Button color="error" onClick={() => handleDelete(item?._id)}>
                                <Icon color='error'>delete</Icon>
                            </Button>
                        </ButtonGroup>
                    ),
                }))}
            />

            <InputFormModal
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                details={details}
                type={formType}
                setDetails={setDetails}
                loading={loading}
            />
        </DashboardLayout>
    );
};

export default Days;

const InputFormModal = ({ open, onClose, onSave, details, setDetails, type, loading }) => {
    React.useEffect(() => {
        if (open && type === 'add') {
            setDetails({ name: "", date: "", start_time: "", end_time: "", quiz_duration: "", total_questions: "" });
        }
    }, [open, type, setDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDetails({ ...details, [name]: value });
    };

    const handleSave = () => {
        onSave(details);
    };

    return (
        <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Day' : 'Edit Day'}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Name"
                    name="name"
                    value={details.name}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    disabled={loading}
                />
                <TextField
                    label="Date"
                    name="date"
                    type="date"
                    value={details.date}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    disabled={loading}
                />
                <TextField
                    label="Start Time"
                    name="start_time"
                    type="time"
                    value={details.start_time}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    disabled={loading}
                />
                <TextField
                    label="End Time"
                    name="end_time"
                    type="time"
                    value={details.end_time}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    disabled={loading}
                />
                <TextField
                    label="Quiz Duration (minutes)"
                    name="quiz_duration"
                    type="number"
                    value={details.quiz_duration}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    disabled={loading}
                />
                <TextField
                    label="Total Questions"
                    name="total_questions"
                    type="number"
                    value={details.total_questions}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    disabled={loading}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" disabled={loading}>
                    Cancel
                </Button>
                {loading ? (
                    <Box sx={{ px: 2, py: 1 }}>
                        <CircularProgress size={24} />
                    </Box>
                ) : (
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant="contained"
                        style={{ color: 'white' }}
                        disabled={
                            !details.name ||
                            !details.date ||
                            !details.start_time ||
                            !details.end_time ||
                            !details.quiz_duration
                        }
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

